import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

/**
 * Breadcrumb segment. Always renders a trailing ' /'.
 * Stack multiple Breadcrumbs before a HeaderTitle to build up a path.
 *
 * @param {React.ReactNode} props.children   - Label text for this segment
 * @param {Function}        [props.onClick]  - Click handler (navigate to this level)
 * @param {string}          [props.className]
 */
const Breadcrumb = ({ children, onClick, className }) => {
  const classes = useStyles();

  return (
    <span className={clsx(classes.root, className)}>
      <button className={classes.link} onClick={onClick}>
        {children}
      </button>
      <span className={classes.separator}>/</span>
    </span>
  );
};

export default Breadcrumb;

const useStyles = makeStyles(() => ({
  root: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
  },

  link: {
    fontFamily: "Lato, sans-serif",
    fontSize: "24px",
    fontWeight: "normal",
    lineHeight: "normal",
    color: "rgba(12, 14, 41, 0.45)",
    background: "none",
    border: "none",
    padding: "0",
    margin: "0",
    cursor: "pointer",
    transition: "color 0.15s ease-in-out",

    "&:hover": {
      color: "rgba(12, 14, 41, 0.7)",
    },
  },

  separator: {
    fontFamily: "Lato, sans-serif",
    fontSize: "24px",
    fontWeight: "normal",
    lineHeight: "normal",
    color: "rgba(12, 14, 41, 0.45)",
    userSelect: "none",
    marginRight: "8px",
  },
}));
